const getTextOfNode = (node: HTMLElement) => {
  let text = "";
  if (node.classList?.contains("node-citation")) return "";
  if (node.nodeType === Node.TEXT_NODE) {
    text = node.textContent?.trim() || "";
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (const child of node.childNodes) {
      text += getTextOfNode(child as HTMLElement);
    }
  }
  return text;
};

const getTableAsString = (tableElement: HTMLTableElement) => {
  if (!(tableElement instanceof HTMLTableElement)) {
    throw new Error("Please provide a valid table element");
  }

  // Process table into CSV format
  const rows = Array.from(tableElement.rows);
  const csvContent = rows
    .map((row) => {
      const cells = Array.from(row.cells);
      return cells
        .map((cell) => {
          // Get the text content and clean it
          let text = getTextOfNode(cell);

          return text;
        })
        .join("\t"); // Use tab as delimiter for better spreadsheet compatibility
    })
    .join("\n");

  return csvContent;
};

export default getTableAsString;
